import React from "react";
import { twMerge } from "tailwind-merge";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  rightElement?: React.ReactNode;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      type = "text",
      className = "",
      disabled = false,
      error = false,
      rightElement,
      ...props
    },
    ref,
  ) => {
    const inputClasses = twMerge(
      "h-11 w-full rounded-lg border px-4 text-base shadow-theme-xs",
      "placeholder:text-gray-400 outline-none focus:border-sky-500 focus:ring-4 focus:ring-sky-500/20",
      "bg-white text-text-primary transition-colors",
      rightElement ? "pr-12" : "",
      disabled
        ? "cursor-not-allowed border-gray-300 text-text-secondary dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400"
        : error
          ? "border-error-300 focus:border-error-300 dark:border-error-500/50"
          : "border-gray-300 focus:border-brand-300 dark:border-gray-700 dark:focus:border-brand-800",
      className,
    );

    return (
      <div className="relative">
        <input
          ref={ref}
          type={type}
          disabled={disabled}
          className={inputClasses}
          {...props}
        />
        {rightElement ? (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            {rightElement}
          </div>
        ) : null}
      </div>
    );
  },
);

Input.displayName = "Input";

export default Input;
